<template>
  <el-dialog title="填写执行考核信息" :append-to-body="true" :modal-append-to-body="true"
             :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="600px"
             height="80%"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div style="padding: 5px 8px;">

          <div class="append">
            <span class="item2">考核金额:</span>
            <el-input placeholder="请输入内容" v-model="standardAmount" :disabled="true" style="width: 110px;">
            </el-input>
          </div>
          <div class="append">
            <span class="item2">调整金额:</span>
            <el-input placeholder="请输入内容" v-model="adjustAmount" @input="change($event)" oninput="if(value<-9999.99||value>9999.99)value=0" style="width: 110px;">
            </el-input>
          </div>
          <div class="append">
            <span class="item2">总金额:</span>
            <el-input placeholder="请输入内容" v-model="amount" :disabled="true" style="width: 110px;">
            </el-input>
          </div>
          <div class="append">
            <span class="item2">最后审批金额:</span>
            <el-input placeholder="请输入内容" v-model="checkAmount" :disabled="true" style="width: 110px;">
            </el-input>
          </div>
          <div class="append">
            <span class="item1">申诉内容:</span>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" :disabled="true"
                      v-model="formData.siteAnswerNote" style="width: 400px;">
            </el-input>
          </div>
          <div class="append">
            <span class="item1">审批意见:</span>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容"
                      v-model="formData.checkNote" style="width: 400px;">
            </el-input>
          </div>
          <div class="append">
            <div class="append">
              <span class="item1">凭证1:</span>
              <div>
                <el-upload style="display:flex"
                           :action="api.uploadFileUrl" :on-remove="handleRemove1" list-type="picture-card"
                           :file-list="picList1"
                           :on-success="(res,file, fileList) => {handleSuccess1(res,file, fileList)}"
                           :on-change="(files, fileList) => {handleImageChange(fileList)}"
                           :auto-upload="true" :headers="headers">
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </div>
            </div>
            <div class="append">
              <span class="item1">凭证2:</span>
              <div>
                <el-upload style="display:flex"
                           :action="api.uploadFileUrl" :on-remove="handleRemove2" list-type="picture-card"
                           :file-list="picList2"
                           :on-success="(res,file, fileList) => {handleSuccess2(res,file, fileList)}"
                           :on-change="(files, fileList) => {handleImageChange(fileList)}"
                           :auto-upload="true" :headers="headers">
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </div>
            </div>
            <div class="append">
              <span class="item1">凭证3:</span>
              <div>
                <el-upload style="display:flex"
                           :action="api.uploadFileUrl" :on-remove="handleRemove3" list-type="picture-card"
                           :file-list="picList3"
                           :on-success="(res,file, fileList) => {handleSuccess3(res,file, fileList)}"
                           :on-change="(files, fileList) => {handleImageChange(fileList)}"
                           :auto-upload="true" :headers="headers">
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
<!--			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>-->
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commit" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import store from "@/store";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";

export default {
  name: 'saleConfigDialog',

  props: ['visiable', 'multi', 'param', 'auditData'],
  mixins: [selectDialogMixins],
  components: {pager},

  created() {
    this.formData = this.auditData
    this.amount = this.formData.amount
    this.standardAmount = this.formData.standardAmount
    this.adjustAmount = this.formData.adjustAmount
    this.checkAmount = this.formData.checkAmount
    console.log(this.formData)
    if (this.formData.proofAttachment1 !== '' && this.formData.proofAttachment1 !== null) {
      this.picList1 = echoFileFormat(this.formData.proofAttachment1)
    }
    if (this.formData.proofAttachment2 !== '' && this.formData.proofAttachment2 !== null) {
      this.picList2 = echoFileFormat(this.formData.proofAttachment2)
    }
    if (this.formData.proofAttachment3 !== '' && this.formData.proofAttachment3 !== null) {
      this.picList3 = echoFileFormat(this.formData.proofAttachment3)
    }
    this.initSetting();
  },

  watch: {
    adjustAmount: {
      handler(newVal) {
        if (this.standardAmount !== '') {
          this.amount = Number(newVal) + Number(this.standardAmount)
          this.checkAmount = this.amount
        }
      }
    },
    picList1: {
      handler(newVal, oldVal) {
        this.formData.proofAttachment1 = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
    picList2: {
      handler(newVal, oldVal) {
        this.formData.proofAttachment2 = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
    picList3: {
      handler(newVal, oldVal) {
        this.formData.proofAttachment3 = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
  },

  computed: {
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      }
    },
  },

  data() {
    return {
      standardAmount: '',
      adjustAmount: '',
      amount: '',
      checkAmount: '',
      formData: {
        id: '',
        standardAmount: '',  // 考核金额
        adjustAmount: '',  // 调整金额
        amount: '',  // 合计金额:standardAmount+adjustAmount
        proofAttachment1: '',  // 考核凭证1
        proofAttachment2: '',  // 考核凭证2
        proofAttachment3: '',  // 考核凭证3
        siteAnswerNote: '',  // 网点申诉意见
        checkAmount: '',  // 最终审批金额(结算时使用此金额)
        checkNote: ''
      },
      picList1: [],
      picList2: [],
      picList3: [],


      upload_btn4: false, // 是否隐藏上传图片按钮
      input: '',
      input2: '',
      input3: '',
      input4: '',
      textarea2: '',
      textarea3: '',
      tenant: {},
      activeName: 'first',
      total: 0,
      filterText: '',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        id: "id",
        isLeaf: "leaf"
      },
      pageSizes: [10, 20, 100],
      //以上树形
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,

      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchItemName: '',
      searchItemCode: '',
      searchBrandName: '',
      selectedRow: {
        id: '', name: ''
      }
    };
  },


  methods: {
    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    change(e) {
      this.$forceUpdate()
    },

    commit() {
      this.formData.amount = this.amount
      this.formData.checkAmount = this.checkAmount
      this.formData.adjustAmount = this.adjustAmount
      this.formData.standardAmount = this.standardAmount
      console.log(this.formData, '执行审核数据')
      this.$http({
        url: api.sfCheckBill.auditDataUrl,
        method: 'post',
        data: this.formData
      }).then(res => {
        this.$message.success('操作成功')
        this.$emit('isAudit')
        this.dialogClose()
        // this.
      })
    },



    handleRemove1() {
      this.picList1 = []
    },
    handleSuccess1(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList1 = [
        {url: res.data.url}
      ]
    },

    handleRemove2() {
      this.picList2 = []
    },
    handleSuccess2(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList2 = [
        {url: res.data.url}
      ]
    },

    handleRemove3() {
      this.picList3 = []
    },
    handleSuccess3(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList3 = [
        {url: res.data.url}
      ]
    },




  }
};
</script>
<style lang="scss" scoped>
.append {
  display: flex;
  margin: 10px 0;

  .item1 {
    display: inline-block;
    width: 110px;
    text-align: right;
    line-height: 45px;
    margin-right: 5px;
  }

  .item2 {
    display: inline-block;
    width: 110px;
    text-align: right;
    line-height: 28px;
    margin-right: 5px;
  }
}


#containt .grid-height {
  height: 570px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}


// 重新修改tree组件样式


// .btn_zdy:hover {
//   color: #00c4b3 !important;
//   border: 1px solid #00c4b3 !important;
// }

::v-deep .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}
</style>
